module.exports = __webpack_public_path__ + "static/media/anushka.9f372c0b.jpeg";